module.exports = __webpack_public_path__ + "media/images/email_icon-d06ba58b.svg";